import { CompanyInformation } from './types';

export const root = '/company';
export const accountClosure = `${root}/account-closure`;

export const getCompanyTabPath = (tab: CompanyInformation) => `${root}#${tab}`;
